import { Component } from "projen";
import { AgentRule, AgentSkill, AgentSubAgent } from "../types";

/**
 * Renders agent configuration files for GitHub Copilot.
 *
 * Output files (future):
 * - .github/copilot-instructions.md — root instructions
 * - .github/instructions/*.instructions.md — scoped instructions
 *
 * TODO: Implement in a future issue.
 */
export class CopilotRenderer {
  public static render(
    _component: Component,
    _rules: ReadonlyArray<AgentRule>,
    _skills: ReadonlyArray<AgentSkill>,
    _subAgents: ReadonlyArray<AgentSubAgent>,
  ): void {
    // Copilot renderer is not yet implemented.
  }
}
